import type { NewUserQuizCopy } from '../types';

export const ES_NEW_USER_QUIZ_COPY = {
  booking: {
    bookedSnackbar: 'Tu demo está reservada. ¡Nos vemos!',
    bullets: {
      pricing: 'Precios claros según el volumen y el nivel de soporte',
      teams: 'Diseñado para equipos: revisores, glosarios y una única biblioteca',
      setup: 'Descubre la configuración adecuada para tu contenido y flujo de trabajo',
    },
    description: 'Descubre cómo Rask mantiene la identidad, la intención y el contexto entre idiomas.',
    heading: 'Descubre cómo Rask encaja en tu flujo de trabajo',
    headingSecondLine: 'Reserva una demo: descubre Rask en acción',
    maybeLater: 'Quizá más tarde',
    rating: '4,7/5 en G2',
    scheduler: {
      openBookingPage: 'Abrir página de reserva',
      loadErrorDescription:
        'Es posible que tu red o región esté bloqueando el contenido insertado. Abre la página de reserva en una pestaña nueva.',
      loadErrorTitle: 'No se ha podido cargar el calendario',
      loadingLabel: 'Cargando el calendario',
    },
    trustedBy: 'Equipos de todo el mundo confían en Rask',
  },
  controls: {
    back: 'Atrás',
    continue: 'Continuar',
    continueAnyway: 'Continuar de todos modos',
    progress: (currentStep, totalSteps) => `Pregunta ${currentStep} de ${totalSteps}`,
    submitError: 'No hemos podido guardar tus respuestas. Inténtalo de nuevo.',
  },
  priorityQuestion: {
    title: '¿Qué es lo más importante para ti al localizar videos?',
    options: {
      collaborate_with_team_or_reviewers: { label: 'Colaboración con el equipo o los revisores' },
      consistent_voice_and_terminology: { label: 'Voz y terminología coherentes' },
      fast_results_no_setup: { label: 'Resultados rápidos, sin configuración' },
      integration_into_product_or_workflow: { label: 'Integración en nuestro producto o flujo de trabajo' },
      not_sure_yet: { label: 'Todavía no lo tengo claro' },
    },
    subtitle: 'Selecciona todas las opciones que correspondan',
  },
  questions: {
    content_team_size: {
      title: '¿Qué tamaño tiene tu equipo de contenidos?',
      options: {
        just_me: { label: 'Solo yo' },
        large_team_5_plus: { label: 'Un equipo grande', description: '5 personas o más' },
        small_team_2_5: { label: 'Un equipo pequeño', description: 'De 2 a 5 personas' },
      },
    },
    localization_frequency: {
      title: '¿Con qué frecuencia traduces, doblas o localizas videos?',
      options: {
        continuously: { label: 'Continuamente', description: 'Volumen de trabajo continuo' },
        occasionally_quarterly: { label: 'De vez en cuando', description: 'Aproximadamente cada trimestre' },
        regularly_monthly: { label: 'Regularmente', description: 'Cada mes' },
        one_time_project: { label: 'Proyecto puntual', description: 'Un único proyecto, sin continuidad' },
      },
    },
    localized_videos_before: {
      title: '¿Has localizado videos antes?',
      options: {
        false: { label: 'No' },
        true: { label: 'Sí' },
      },
      subtitle: 'Unas preguntas rápidas para personalizar tu experiencia',
    },
    target_language_count: {
      title: '¿A cuántos idiomas tienes previsto localizar tus videos?',
      options: {
        changes_by_project: { label: 'Varía según el proyecto', description: 'Sin un número fijo' },
        four_to_ten: { label: '4 – 10', description: 'Varios mercados a la vez' },
        ten_plus: { label: '10+', description: 'Lanzamiento amplio y a gran escala' },
        two_to_three: { label: '2 – 3', description: 'Un par de mercados' },
        one: { label: '1', description: 'Un solo idioma' },
      },
    },
  },
} satisfies NewUserQuizCopy;
